module.exports = __webpack_public_path__ + "assets/img/toc-per-icon.b46dba31.svg";